import { contributorKey } from "./contributor-key";
export const TIP_TAGS = [
	"앞이 잘 보여요",
	"가림 있어요",
	"단차 좋아요",
	"무릎 좁아요",
	"소리 좋아요",
	"소리 울려요",
	"출입 편해요",
	"계단 많아요",
];
export function seatKey(seat: {
	venueId: string;
	layoutVersionId: string;
	sectionCode: string;
	rowLabel: string;
	seatNumber: number;
}) {
	return [
		seat.venueId,
		seat.layoutVersionId,
		seat.sectionCode,
		seat.rowLabel,
		seat.seatNumber,
	].join(":");
}
export async function contributionRequest<T>(
	path: string,
	method = "GET",
	body?: unknown,
	token?: string,
	operationId?: string,
): Promise<T> {
	const response = await fetch(path, {
		method,
		headers: {
			"content-type": "application/json",
			"x-contributor-key": contributorKey(),
			...(operationId ? { "x-client-op-id": operationId } : {}),
			...(token ? { "cf-turnstile-response": token } : {}),
		},
		...(body === undefined ? {} : { body: JSON.stringify(body) }),
	});
	const data = (await response.json()) as T & {
		error?: { code: string; message: string };
	};
	if (!response.ok)
		throw new Error(
			data.error?.message ?? "연결을 확인하고 다시 시도해 주세요.",
		);
	return data;
}

export async function contributionOrQueue<T>(
	path: string,
	body: unknown,
): Promise<{ queued: true } | { queued: false; data: T }> {
	const id = crypto.randomUUID();
	contributorKey();
	const queue = async () => {
		const { enqueue } = await import("./outbox");
		await enqueue({
			clientOpId: id,
			endpoint: path,
			method: "POST",
			body,
			createdAt: new Date().toISOString(),
		});
		return { queued: true } as const;
	};
	if (!navigator.onLine) return queue();
	try {
		return {
			queued: false,
			data: await contributionRequest<T>(path, "POST", body, undefined, id),
		};
	} catch (error) {
		if (!navigator.onLine || error instanceof TypeError) return queue();
		throw error;
	}
}
